import { useEffect, useRef, useState } from "react";
import { Star } from "lucide-react";

const reviews = [
  {
    name: "Dr. Sharon Albright",
    role: "Practice Owner, 20+ Years",
    text: "My qualified new patient leads have skyrocketed as have my new patient numbers in just a few months. Katie, my Client Services Manager, speaks to me in plain English — not jargon. I regret it took me so long to partner with XPress.",
    rating: 5,
  },
  {
    name: "Dr. Sukhjinder Thind",
    role: "Dental Practice Owner",
    text: "Few firms combine Google marketing expertise with exceptional communication and a true commitment to their clients. Their regular check-ins and dedicated point of contact make it easy to raise concerns and quickly course-correct. It genuinely feels like a partnership.",
    rating: 5,
  },
  {
    name: "Elizabeth Alexander",
    role: "Dental Practice Owner, Charlotte NC",
    text: "I have been working with Xpress Promotion for 5+ years. They have been in charge of all my marketing and website and it gives me peace of mind to know that I am in good hands. They are not local for me — but that has never been an issue.",
    rating: 5,
  },
];

const ReviewsSection = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.12 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="py-20 md:py-28 bg-secondary" ref={ref}>
      <div className="max-w-7xl mx-auto section-padding">
        <div className="text-center max-w-2xl mx-auto mb-4">
          <p className="text-accent font-semibold text-sm tracking-wide uppercase mb-3">
            Verified Google Reviews
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground tracking-tight">
            What Our Clients Say
          </h2>
        </div>

        {/* Rating summary */}
        <div className={`flex items-center justify-center gap-3 mb-12 ${visible ? "reveal-up" : "opacity-0"}`}>
          <div className="flex gap-0.5">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" />
            ))}
          </div>
          <span className="text-2xl font-bold text-foreground">5.0</span>
          <span className="text-muted-foreground text-sm">— 58 reviews on Google</span>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {reviews.map((r, i) => (
            <div
              key={r.name}
              className={`bg-card border border-border rounded-xl p-7 shadow-sm hover:shadow-lg transition-shadow duration-300 flex flex-col ${
                visible ? "reveal-up" : "opacity-0"
              }`}
              style={{ animationDelay: `${i * 100}ms` }}
            >
              <div className="flex gap-0.5 mb-4">
                {[...Array(r.rating)].map((_, j) => (
                  <Star key={j} className="w-4 h-4 fill-amber-400 text-amber-400" />
                ))}
              </div>
              <p className="text-sm text-muted-foreground leading-relaxed mb-6 flex-1">
                "{r.text}"
              </p>
              <div className="border-t border-border pt-4">
                <p className="font-bold text-foreground text-sm">{r.name}</p>
                <p className="text-xs text-muted-foreground">{r.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ReviewsSection;
